export default __webpack_public_path__ + "static/media/rkdatta_image_1.3b732c01.svg";